import { MDBBreadcrumb, MDBBreadcrumbItem } from "mdb-react-ui-kit";
import React from "react";
import { Link } from "react-router-dom";
import './style.scss'

const Breadcrumb = React.memo((props) => {
    const { breadcrumb } = props;

    const handleItemClick = (e, bc) => {
        bc.onClick && bc.onClick();
    }

    if(breadcrumb?.length > 0) {
        return <div className="d-flex px-4">
            <label className="me-2">Position : </label>
            <MDBBreadcrumb>
                {breadcrumb.map((bc, index) => (
                    <MDBBreadcrumbItem 
                        key={index} 
                        active={index == breadcrumb.length - 1} 
                        onClick={e=>handleItemClick(e, bc)}
                        style={{
                            cursor: (bc.url || bc.onClick) ? 'pointer' : ''
                        }}
                    >
                        {(bc.url || bc.onClick) && <Link to={bc.url}>{bc.title}</Link> }
                        {!bc.url && !bc.onClick && <span>{bc.title}</span>}
                    </MDBBreadcrumbItem>
                ))}
            </MDBBreadcrumb>
        </div>
    } else {
        return <></>
    }
})

export default Breadcrumb;